import React from 'react';
import uid from 'utils/uid';
import tulkojumi from 'utils/tulkojumi';
import {
  StyledSwiper,
  Container,
  Wrapper,
  Slide,
  StyledNavigation,
  NavigationButton,
} from './styled';
import '../../css/swiper';
import { default as SwiperJs } from 'swiper/dist/js/swiper.min.js';

class Swiper extends React.PureComponent {
  constructor(props) {
    super(props);
    this._uid = uid();
    this._className = `js-swiper-${this._uid}`;
  }

  componentDidMount() {
    // NOTE: SSR ģenerēts uid
    this._uid = this._getUidFromDom();
    this._className = `js-swiper-${this._uid}`;

    const {
      slides,
      teksti,
      slideChanged,
      beforeSlideChange,
      swiperInit
    } = this.props;

    if (slides && slides.length > 1) {
      this._swiper = new SwiperJs(`.${this._className}`, {
        slidesPerView: 'auto',
        a11y: {
          prevSlideMessage: tulkojumi(teksti, 'ieprieksejais_slaids'),
          nextSlideMessage: tulkojumi(teksti, 'nakamais_slaids'),
          firstSlideMessage: tulkojumi(teksti, 'sis_ir_pirmais_slaids'),
          lastSlideMessage: tulkojumi(teksti, 'sis_ir_pedejais_slaids'),
          paginationBulletMessage: `${tulkojumi(teksti, 'iet_uz_slaidu')} {{index}}`,
        },
        loop: true,
        navigation: {
          prevEl: `.${this._className}-prev`,
          nextEl: `.${this._className}-next`,
        },
        keyboard: true,
        on: {
          init: () => {
            swiperInit && swiperInit()
          },
          slideChange: () => {
            this._swiper && beforeSlideChange && beforeSlideChange(this._swiper.realIndex);
          },
          slideChangeTransitionEnd: () => {
            this._swiper && slideChanged && slideChanged(this._swiper.realIndex);
          },
        },
      });
    }
  }

  _getUidFromDom = () => {
    const classList = Array.from(this._container.classList);
    const jsClass = classList.find(className => className.startsWith('js-swiper-'));
    if (jsClass) {
      const pattern = /^js-swiper-(.*)$/;
      const [, uid] = pattern.exec(jsClass) || [];
      return uid;
    }
  }

  _wrapNavigation = (button, type) => {
    return (
      <NavigationButton className={`${this._className}-${type}`}>
        {button}
      </NavigationButton>
    );
  }

  update() {
    if (this._swiper) {
      this._swiper.update();
    }
  }

  render() {
    const {
      slidesPerView,
      spaceBetween,
      overlayNav,
      prevButton,
      nextButton,
      marginStyle
    } = this.props;

    const { slides } = this.props;
    return (
      <StyledSwiper
        spaceBetween={spaceBetween}
      >
        <Container
          innerRef={c => this._container = c}
          className={`swiper-container ${this._className}`}
          spaceBetween={spaceBetween}
        >
          <Wrapper
            className='swiper-wrapper'
            spaceBetween={spaceBetween}
          >
            {
              slides.map((slide, i) => (
                <Slide
                  key={`slide-${i}`}
                  className='swiper-slide'
                  slidesPerView={slidesPerView}
                >
                  {slide}
                </Slide>
              ))
            }
          </Wrapper>
        </Container>

        {
          slides && slides.length > 1 && (
            <StyledNavigation marginStyle={marginStyle} overlayNav={overlayNav}>
              {this._wrapNavigation(prevButton, 'prev')}
              {this._wrapNavigation(nextButton, 'next')}
            </StyledNavigation>
          )
        }
      </StyledSwiper>
    );
  }
}

export default Swiper;



// WEBPACK FOOTER //
// ./src/modules/Swiper/Swiper.jsx